import { render, staticRenderFns } from "./CheckoutGenericError.vue?vue&type=template&id=db5b1634"
import script from "./CheckoutGenericError.vue?vue&type=script&lang=js"
export * from "./CheckoutGenericError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports